import { ComCustomerCommerceRestCalendarHandlerFetchCalendar } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

import { loggerCan } from '@/data/utils/loggerUtil';
import { logger } from '@/logging/logger';

export class ErpCalendar<SecurityDataType = unknown> {
	http: HttpClient<SecurityDataType>;
	traceDetails: string | undefined;

	constructor(http: HttpClient<SecurityDataType>) {
		this.http = http;
		this.traceDetails = process.env.TRACE_DETAILS?.trim();
	}

	/**
	 * No description
	 *
	 * @tags ErpCalendar
	 * @name ErpCalendar
	 * @summary ERP Calendar.
	 * @request GET:/store/{storeId}/fca/calendar/erp_calendar
	 * @secure
	 * @response `200` `ComCustomerCommerceRestCalendarHandlerFetchCalendar` The requested completed successfully.
	 * @response `400` `void` Bad request. Some of the inputs provided to the request aren't valid.
	 * @response `401` `void` Not authenticated. The user session isn't valid.
	 * @response `403` `void` The user isn't authorized to perform the specified request.
	 * @response `404` `void` The specified resource couldn't be found.
	 * @response `500` `void` Internal server error. Additional details will be contained on the server logs.
	 */
	erpCalendar = (
		storeId: string,
		query?: {
			/**
			 * number of days to return.
			 * @example 30, 60
			 */
			noOfDays?: number;
			/**
			 * Dater from.
			 * @example 2025-01-01, 2025-12-24
			 */
			dateFrom?: string;
			/**
			 * Delivery zip code.
			 * @example 41756, 94135
			 */
			zipCode?: string;
			/**
			 * Delivery zip code.
			 * @example 1140, 2084
			 */
			projectId?: string;
		},
		params: RequestParams = {}
	) => {
		const { _requestId: requestId } = params as any;
		delete (params as any)._requestId;

		if (loggerCan('trace') && (!this.traceDetails || this.traceDetails.includes('erpCalendar'))) {
			const paramsLogger = logger.child({
				params,
				query: query ?? {},
				body: null ?? {},
				methodName: 'erpCalendar',
				requestId,
			});
			paramsLogger.trace('API request parameters');
		}
		return this.http.request<ComCustomerCommerceRestCalendarHandlerFetchCalendar, void>({
			path: `/store/${storeId}/fca/calendar/erp_calendar`,
			method: 'GET',
			query: query,
			secure: true,
			format: params.format ?? 'json',
			storeId,
			...params,
		});
	};
}
